<app-popin-container>
  <app-avis-google-details [popinReviewDetails]="data" />
</app-popin-container>
